const PageTitle = ({ children }) => {
  return (
    <h3 className="text-base font-semibold text-zinc-900">{children}</h3>
  );
};

export default PageTitle;